import './css/Aulas.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Espera from '../Espera';
import CONFIG from '../../config';

const URL  = `${CONFIG.API_URL}/operarCursos.php`;

function MisCursos({acceder, rolSelect, rol}) {
    const [espera, setEspera] = useState(false);
    const [cursos, setCursos] = useState([]);
    const loggeduserId =localStorage.getItem('loggeduserId');
    const loggeduserNombreCompleto =localStorage.getItem('loggeduserNombre');
    const loggeduserDatos =JSON.parse(localStorage.getItem('loggeddatosuser'));
    const navigate = useNavigate();
    

    useEffect(() => {
        if(acceder){
            if((rol===null) || (rol<5)  || (rol>=8)){
                navigate("/");
                //console.log(rolSelect);
            }else{
                const data= {
                    'id_usuario' : loggeduserId,
                    'modo': 'buscarCursosUsuario',
                    'llama':rol
                }
                // console.log(data);
                setEspera(true);
                axios.post(URL, data)
                .then(res =>{
                    //console.log(JSON.stringify(res.data));
                    (!res.data.error)?setCursos(res.data):setCursos([]);
                    setEspera(false);
                })
                .catch(err=>{
                    console.log(err);
                })
            }
        }else{
            localStorage.clear();
            navigate('/');
        }        
    }, [acceder, rol, navigate, loggeduserId]);

    const entrarEnCurso =(cur)=>{
        localStorage.setItem('loggeduserCurso', cur.id );
        localStorage.setItem('loggeduserCursoGrupo',  cur.id_curso_grupo);
        localStorage.setItem('loggeduserCursoGrupoO',  JSON.stringify(cur));
        navigate(`/MC/${cur.id}`);
    }
    const verPlanificacion =(e, cur)=>{
        e.stopPropagation(); // Detener la propagación del evento
        localStorage.setItem('loggeduserCurso', cur.id );
        localStorage.setItem('loggeduserCursoGrupo',  cur.id_curso_grupo);
        localStorage.setItem('loggeduserCursoGrupoO',  JSON.stringify(cur));
        //console.log(`/MC/${cur.id}/P/${cur.id_curso_grupo}`)
        navigate(`/MC/${cur.id}/P/${cur.id_curso_grupo}`);
    }
    const mostrarNombre = (orden)=>{
        let nombre="";
        switch(orden){
          case "S2":
            nombre='Sala de 2';
            break
          case "S3":
            nombre='Sala de 3';
          break
          case "S4":
            nombre='Sala de 4';
          break
          case "S5":
            nombre='Sala de 5';
          break
          case "In":
            nombre='Espacio Institucional';
          break
          default:
            nombre=orden+'°';
        }
        return nombre
      };
    return ( 
            <div className='container-principal'>
                <h4>Hola, {loggeduserDatos.apodo===''?loggeduserDatos.nombre:loggeduserDatos.apodo} {loggeduserDatos.genero===''?loggeduserDatos.nombre:loggeduserDatos.apodo}bienvenida/o.</h4>
                {!espera ? 
                <div className='row row-cols-1 row-cols-md-3 row-cols-xl-4'>  
                {cursos.length==0?
                    <>
                        <div className='text-center'>No estas en ningún curso</div>
                        <img width={350} src='https://www.institutopetitdemeurville.com.ar/img/2953962.jpg' />
                            </>
                    :<>          
                    {cursos.map((c, index)=>(
                    <div key={index}>
                        <div className="card-estructura" onClick={() => entrarEnCurso(c)} >
                            <img src={c.imagen === '' ? `${CONFIG.API_URL}/${c.caratula_formacion}` : c.imagen} className="card-img-top" alt='imagen-decorativa' />
                            <p className="card-text">Ciclo lectivo: {c.cohorte}</p>
                            <div className="caja-cuerpo2">
                                <h6 >{mostrarNombre(c.orden)} - {c.nombre_espacio}</h6>
                                <p>Sala/grupo: {c.denominacion}</p> 
                                <p><i className="fa-solid fa-list-check"></i> Planificacion: {(c.id_planificacion === 0) ? <button type='button' className='btn btn-outline-primary btn-sm' onClick={(e)=>verPlanificacion(e,c)}>SI</button>:'NO'}</p>
                                <p><i className="fa-solid fa-people-group"></i> Estudiantes: {c.cant_estudiantes}</p>
                            </div>
                        </div>
                    </div>
                    ))}
                </>    
                }
                </div>:<div className='container m-3'><Espera visible={espera} /></div> } 
            </div>
     );
}

export default MisCursos;